module.exports = __webpack_public_path__ + "static/media/baloon.ec37e7ed.svg";